import { createBuilderModule } from '../../../builder';
import { COLOR_KEYS_LIST } from '../../../constants';
import { SectionName, withTracking } from '../../../observability';
import { SimpleFeaturesSection } from './SimpleFeaturesSection';

export default createBuilderModule(
  withTracking(SimpleFeaturesSection, {
    sectionName: SectionName.SimpleFeaturesSection,
  }),
  {
    name: 'SimpleFeaturesSection',
    image: 'https://cdn.zappy.app/f54262fe4b8e4850252a6773b76b0d39.png',
    inputs: [
      { name: 'heading', type: 'string' },
      {
        name: 'columns',
        type: 'list',
        subFields: [
          { name: 'heading', type: 'string' },
          { name: 'description', type: 'string' },
          { name: 'linkText', type: 'string' },
          { name: 'href', type: 'string' },
        ],
      },
      {
        name: 'backgroundColor',
        type: 'string',
        enum: ['', ...COLOR_KEYS_LIST],
      },
      {
        name: 'disableSpacing',
        type: 'boolean',
      },
    ],
  },
);
